export function getUsLocaleString(date: Date): string {

  if(!date){
    return "N/A"
  }

  return date.toLocaleTimeString(["en-US"], { year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit" }).replaceAll(",", "");
}

export function getCurrentDate(): string {
  var time = new Date();
  return time.toLocaleTimeString(["en-US"], { year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit" }).replaceAll(",", "");
}

export function convertTimeString(time?: string): string {
  if (time) {
    return getUsLocaleString(new Date(Date.parse(time)));
  } else {
    return "N/A";
  }
}

export function getSyncLabel(value?: Date): string {
  if (value) {
    return getUsLocaleString(value);
  } else {
    return "Unavailable";
  }
}

export function dateParser(value: string | null): Date | undefined {
  if (value){
    const parsedTimestamp = Date.parse(value);
    return isNaN(parsedTimestamp) ? undefined : new Date(parsedTimestamp)
  }else {
    return undefined
  }
  
}
